export default "__VITE_ASSET__83473b67__"